import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import { LayoutAdmin } from '../layouts/Admin/Admin'
import { RouteRoleGuard } from '../layouts/RouteRoleGuard/RouteRoleGuard'
import BrandSettings from '../pages/brand/settings/Settings'
import BrandSettingsResetPassword from '../pages/brand/settings/ResetPassword'
import BrandSettingsUpdateEmail from '../pages/brand/settings/UpdateEmail'
import SignInMethods from '../components/auth/SignInMethods'
import MyProfile from '../pages/profile/MyProfile'
import TutorialsList from '../pages/tutorials/TutorialsList'
import { PortalEntry } from '../pages/portal/PortalEntry'
import { PortalRedirect } from '../pages/portal/PortalRedirect'

// What a brand client gets at the ROOT of the app (TDC-1609).
//
// Their brand pages live under /portal/:brandSlug/* (router/portalRoutes.tsx).
// What stays here is only what isn't about a brand:
//   - the personal settings tabs — the same page whichever brand you belong to;
//   - tutorials;
//   - the entry redirect and the permanent slug-free -> slugged shim.
//
// The two catch-alls do the real work. The one on /settings is what makes
// legacy brand-tab links (/settings/team) keep working without listing them:
// they fall through to PortalRedirect, which reads the whole pathname.
export const BrandRootRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <RouteRoleGuard roles={['BRAND_ADMIN', 'BRAND_MEMBER', 'BRAND_TEAM_SALES']}>
        <LayoutAdmin />
      </RouteRoleGuard>
    ),
    children: [
      { index: true, element: <PortalEntry /> },
      {
        path: 'settings',
        element: <BrandSettings />,
        children: [
          { index: true, element: <Navigate to="/settings/profile" replace /> },
          { path: 'profile', element: <MyProfile /> },
          { path: 'reset-password', element: <BrandSettingsResetPassword /> },
          { path: 'update-email', element: <BrandSettingsUpdateEmail /> },
          { path: 'sign-in-methods', element: <SignInMethods /> },
          // Brand-scoped tabs (team, api-keys, onboarding, notifications,
          // brand-profile) live in the portal — send them there rather than
          // enumerating them.
          { path: '*', element: <PortalRedirect /> },
        ],
      },
      { path: 'tutorials', element: <TutorialsList /> },
      // Everything else a brand client can ask for at the root is a page that
      // now lives under their slug.
      { path: '*', element: <PortalRedirect /> },
    ],
  },
]
